import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import Img from "gatsby-image/withIEPolyfill"
import _ from "lodash"

import { COLORS } from "../../../theme/styles/globals"
import Carousel from "../../atomic/molecules/Carousel"

export default class ContentfulBlockClients extends React.Component {

    render() { 

        const { logos, mode } = this.props

        const mobileLogos = _.chunk(logos, 4)

        return ( 
            <Container>
                <CarouselWrap>
                    <Carousel
                        id={"client-list"}
                        mode={mode}
                        slidesPerView={1.1}
                        centeredSlides={true}
                        spaceBetween={10}
                        message={false}
                        autoplay={{ delay: 2500 }}
                    >
                    {mobileLogos.map((group, i) => (
                        <MobileLogoWrap key={i}>
                        {group.map((logo, k) => (
                            <Logo key={k}>
                                <Image src={logo.file.url} />
                            </Logo>
                        ))}
                        </MobileLogoWrap>
                    ))}
                    </Carousel>
                </CarouselWrap>
                <LogoWrap>
                {logos.map((logo, i) => (
                    <Logo key={i}>
                        <Image src={logo.file.url} />
                    </Logo>
                ))}
                </LogoWrap>
            </Container> 
        )
    }

}

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  ${up('md')}{
    display:flex;
    flex-direction: row;
    justify-content:center;
    align-items:center;
  }
`

const LogoWrap = styled.div`
    display:none;

    ${up('md')}{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
        gap: 1vh 5vh;
        grid-template-areas:
        ". . . . ."
        ". . . . ."
        ". . . . ."
        ". . . . ."
        ". . . . .";
        width:130vh;
        height:70vh;
        position:relative;

        &::after{
            content: " ";
            width:80%;
            height:60%;
            background:${COLORS.DARK_GREY_2};
            position:absolute;
            top:20%;
            left:10%;
            z-index:-1;
        }
    }
`

const Logo = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:100%;
    height:100%;
`

// const Image = styled(Img)`
//     width:100%;
//     height:100%;
// `

const Image = styled.img`
    width:80%;
    height:80%;
`

const MobileLogoWrap = styled.div`
    background:${COLORS.DARK_GREY_2};
    padding:20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 0px 10px;
    grid-template-areas:
        ". ."
        ". .";
    width:100%;
    height:240px;
`

const CarouselWrap = styled.div`
  display: block;
  padding-top: 30px;
  padding-bottom: 30px;
  ${up("md")} {
    display: none;
  }
`